<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Danh sách ticket" :link="[{ text: 'Ticket', href: '../student-tickets' }]" />
      </div>
      <div class="d-flex flex-wrap justify-end flex-gap"></div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <StudentTicketFilter ref="student-filter" @onFilterChanged="filterStudent" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <StudentTicketTable ref="student-data-table" />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import StudentTicketFilter from '../../modules/studentTicket/StudentTicketFilter.vue'
import StudentTicketTable from '../../modules/studentTicket/StudentTicketTable.vue'

export default {
  components: {
    Breadcrumbs,
    StudentTicketFilter,
    StudentTicketTable,
  },
  data() {
    return {
      isShowAddExcel: true,
      createState: false,
      showExcelDialog: false,
      studentFilters: { status: 'active' },
    }
  },
  computed: {},
  methods: {
    filterStudent(query) {
      this.studentFilters = { ...query }
      this.$refs['student-data-table'].searchStudentTickets(query)
    },
  },
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
.flex-gap {
  row-gap: 24px;
}
</style>
